import CacheService from '../cache-service';

class RecommendedArticlesService extends CacheService {
  getArticles() {
    return this.getCachedData('/api/recommended-articles');
  }
}

const recommendedArticlesService = new RecommendedArticlesService();

export default recommendedArticlesService;